import {NodeDeclChunk} from "../chunks/types/NodeDeclChunk";
import {getNameFromIdentifierChunk} from "./utils/getNameFromIdentifier";

export function nodeDeclChunkToNodeName(
  nodeDeclChunk: NodeDeclChunk
): string {
  const {
    captures: {
      2: identifierChunk
    }
  } = nodeDeclChunk;
  return getNameFromIdentifierChunk(identifierChunk);
}
